import { ManageTable, type ManageField } from '@/components/ManageTable'
import { CodeEditor } from '@/components/CodeEditor'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export default function Apis() {
  const [filterValues, setFilterValues, clearFilters] = usePersistentState<
    Record<string, string>
  >(
    'admin:apis:filters',
    {},
  )
  const filters = Object.fromEntries(
    Object.entries(filterValues)
      .filter(([, value]) => value.trim())
      .map(([field, value]) => [
        field,
        { $regex: `.*${escapeRegex(value.trim())}.*`, $options: 'i' },
      ]),
  )

  const updateFilter = (field: string, value: string) => {
    setFilterValues((currentFilters) => {
      const nextFilters = { ...currentFilters }
      if (value) {
        nextFilters[field] = value
      } else {
        delete nextFilters[field]
      }
      return nextFilters
    })
  }

  const fields: ManageField[] = [
    {
      desc: 'func',
      field: 'func',
    },
    {
      desc: '描述',
      field: 'name',
    },
    {
      desc: '路径',
      field: 'path',
    },
    {
      desc: '请求参数',
      field: 'request_params',
      Comp: <CodeEditor language="json" />,
      NoShowInTable: true,
    },
    {
      desc: '返回参数',
      field: 'resp_params',
      Comp: <CodeEditor language="json" />,
      NoShowInTable: true,
    },
    {
      desc: 'hook',
      field: 'hook',
      Comp: <CodeEditor language="python" />,
      NoShowInTable: true,
    },
    {
      desc: '版本',
      field: 'version',
    },
    {
      desc: '更新日期',
      field: 'update_time',
    },
  ]

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">API 管理</h1>

      <ManageTable
        fields={fields}
        collect="apis"
        modalWidth="80%"
        filter={
          <div className="flex items-center gap-3 flex-wrap">
            <Input
              className="w-[180px]"
              placeholder="搜索 func..."
              value={filterValues.func || ''}
              onChange={(e) => updateFilter('func', e.target.value)}
            />
            <Input
              className="w-[220px]"
              placeholder="搜索描述关键词..."
              value={filterValues.name || ''}
              onChange={(e) => updateFilter('name', e.target.value)}
            />
            <Input
              className="w-[260px]"
              placeholder="搜索路径片段..."
              value={filterValues.path || ''}
              onChange={(e) => updateFilter('path', e.target.value)}
            />
          </div>
        }
        filters={filters}
        onResetFilters={clearFilters}
      />
    </div>
  )
}
